import { Navigate } from "react-router-dom";
import { PageMeta } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/Section";
import { SEO } from "@/content/siteContent";
import { LEGAL_PAGES } from "@/content/legalContent";

export default function Legal({ page }) {
    const doc = LEGAL_PAGES[page];
    if (!doc) return <Navigate to="/" replace />;
    const seo = SEO[page];

    return (
        <>
            <PageMeta title={seo.title} description={seo.description} />
            <PageHero eyebrow="Legal" title={doc.title}>
                <p className="mt-6 text-[0.68rem] uppercase tracking-[0.24em] text-[#C8A15A]/80" data-testid="legal-updated">
                    Last updated: {doc.updated}
                </p>
            </PageHero>

            <section className="surface-ivory py-16 sm:py-24" data-testid={`legal-${doc.slug}`}>
                <div className="mx-auto max-w-3xl px-5 sm:px-8">
                    <Reveal>
                        <p className="mb-12 rounded-sm border border-[#A51C30]/25 bg-[#A51C30]/5 px-5 py-4 text-xs font-light leading-relaxed text-[#2b1418]/70" data-testid="legal-review-note">
                            {doc.reviewNote}
                        </p>
                    </Reveal>
                    <div className="space-y-12">
                        {doc.sections.map((s) => (
                            <Reveal key={s.h}>
                                <h2 className="font-display text-2xl font-semibold text-[#260910] sm:text-3xl">
                                    {s.h}
                                </h2>
                                <div className="body-copy mt-4 space-y-4 text-[0.98rem]">
                                    {s.body?.map((p, i) => (
                                        <p key={i}>{p}</p>
                                    ))}
                                    {s.list && (
                                        <ul className="list-disc space-y-2.5 pl-6">
                                            {s.list.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {s.after?.map((p, i) => (
                                        <p key={`a-${i}`}>{p}</p>
                                    ))}
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
